export function formatCurrency(amount) {
  if (amount == null || Number.isNaN(amount)) return '0.00'
  return new Intl.NumberFormat('en-KE', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount))
}
